import {InlinePaymentEngineComponent} from './inline-payment-engine.component';
import {PaymentEngineOptions} from './payment-engine-options';

export class InlinePaymentEngineModule {
    constructor() {
    }

    init(options: PaymentEngineOptions) {
        return new InlinePaymentEngineComponent().init(options);
    }
}



// WEBPACK FOOTER //
// ../inline/src/modules/inline-payment-engine/inline-payment-engine.module.ts